import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserContext } from '../shared/services/user-context.service';

@Injectable({
  providedIn: 'root'
})
export class AnnotatorGuard implements CanActivate {
  constructor(private router: Router, public userContext: UserContext) {}

  canActivate(): boolean {
    if (this.userContext.isAnnotator()) {
      this.router.navigateByUrl('/dashboard'); // Redirect to the dashboard or any other route
      return false; // Deny access for Administrator role????????????
    } else {
      return true; // Allow access for other roles
    }
  }
}
